import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import DataLayer from '../common/data-layer.js';
import { Accordion } from 'react-bootstrap';
import style from './list-card.style.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
var _excluded = ["topic"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var ListCard = function ListCard(_ref) {
  var topic = _ref.topic,
      props = _objectWithoutProperties(_ref, _excluded);

  return jsx(Accordion, _objectSpread(_objectSpread({
    defaultActiveKey: "0",
    flush: true,
    css: style.accordionStyleCustom
  }, props), {}, {
    children: topic.faqList.map(function (detail, index) {
      return jsx(DataLayer, {
        selector: "FaqList#".concat(detail.id),
        triggers: ['click'],
        context: {
          detail: detail
        },
        render: function render(ref) {
          return jsxs(Accordion.Item, {
            ref: ref,
            eventKey: index,
            children: [jsx(Accordion.Header, {
              children: jsxs("div", {
                css: style.accordionHeader,
                children: [jsx("div", {
                  className: "list-no",
                  children: index + 1
                }), ' ', jsx("div", {
                  children: detail.name
                })]
              })
            }), jsx(Accordion.Body, {
              children: detail.detail
            })]
          });
        }
      });
    })
  }));
};

export { ListCard as default };